import moment from "moment";
import React from "react";
import { useIASelector } from "../../redux/hooks";
import { selectedUserSelector } from "../../redux/slices/userSlice";
import { subscriber } from "../../services/RevenueCatServices/RevenueCatTypes";

type Props = {
  subscriber: subscriber;
};

export default function SubscriptionCard({ subscriber }: Props) {
  const selectedUser = useIASelector(selectedUserSelector);

  const getSubscriptionTitle = () => {
    if (!selectedUser) return "";
    if (selectedUser.productId === "iafree") return "Free Account";
    if (selectedUser.subscriptionPlan === "Annual Plan")
      return "Annual Subscription";
    if (selectedUser.subscriptionPlan === "Monthly Plan")
      return "Monthly Subscription";
    if (selectedUser.subscriptionPlan === "Foundation Member")
      return "Foundation Member Subscription";
    return "";
  };

  const getBackgroundColor = () => {
    if (!selectedUser) return;
    if (selectedUser.subscriptionPlan === "Annual Plan") return "#D08D79";
    if (selectedUser.subscriptionPlan === "Monthly Plan") return "#D0CD81";
    if (selectedUser.subscriptionPlan === "Foundation Member") return "#A6A2D3";
  };

  const getPrice = () => {
    if (!selectedUser) return;
    if (selectedUser.subscriptionPlan === "Annual Plan") return "$83.00";
    if (selectedUser.subscriptionPlan === "Monthly Plan") return "$11.99";
    if (selectedUser.subscriptionPlan === "Foundation Member") return "$59.00";
  };

  const getPriceUnit = () => {
    if (!selectedUser) return;
    if (selectedUser.subscriptionPlan === "Monthly Plan") return "Per Month";

    return "Per Year";
  };

  if (!selectedUser) return <div></div>;
  if (selectedUser.subscriptionPlan === "No Plan") return <div></div>;

  return (
    <div className="text-black font-Switzer">
      <div
        style={{ backgroundColor: getBackgroundColor() }}
        className={`rounded-lg p-4 mb-2`}
      >
        <p>{getSubscriptionTitle()}</p>
        <div className="flex items-end mb-2">
          <p className="font-semibold text-2xl">{getPrice()}</p>
          <p className="ml-2">{getPriceUnit()}</p>
        </div>
        <p className="text-[8px]">
          Billed Annually After Free Trial Period Ends
        </p>
      </div>
      <div className="flex flex-row items-center">
        <p className="font-semibold mr-2">Renews on:</p>
        <p>
          {moment(subscriber.entitlements.production.expires_date).format(
            "DD MMMM YYYY"
          )}
        </p>
      </div>
    </div>
  );
}
